export const MOBILE_SIDE_TOOLBAR_OFFSET = { x: 18, y: 0 };
export const SIDE_TOOLBAR_OFFSET = {
  desktop: { x: -43, y: 0 },
  mobile: {
    ios: MOBILE_SIDE_TOOLBAR_OFFSET,
    android: MOBILE_SIDE_TOOLBAR_OFFSET,
  },
};
